import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Chip, IconButton } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import AutocompleteCompo from "../../components/Comman/AutoCompleteCompoForScheme";
import MultiSelectPopover from "../../components/Comman/PopoverCommon";
import { blueFadeColor, lightWhiteFadeColor, redColor } from "../../config/ColorObj";
import { areYouSureMsg, dateValidationMsg, deleteWarningMsg, toDateCannotBeLessThanFromDateMsg } from "../../config/messageconstant";
import { getFormattedDateWithConvertingObj } from "../../utils/dateFormat";
import ProductDetailsPopup from "./ProductDetailsPopUp";
import "./Scheme.css";
import { getSchemeFromDate, subscribeSchemeFromDate } from "./schemestore";

const SchemeConditions = ({
    offerDetails,
    offerLevelDetails,
    productFromCatogoriesList,
    schemeConditonsValidations,
    schemeConditionsDetails,
}) => {

    const [fromDate, setFromDate] = useState(getSchemeFromDate());


    const [formData, setFormData] = useState({
        minQty: "",
        maxQty: "",
        minValue: "",
        maxValue: "",
        discount: "",
        amount: "",
        fromDate: fromDate,
        toDate: "",
    });

    const [errors, setErrors] = useState({});
    const [shake, setShake] = useState({});
    const [rows, setRows] = useState([]);

    const inclusiveAnchorRef = useRef(null);
    const exclusiveAnchorRef = useRef(null);

    const [inclusiveProducts, setInclusiveProducts] = useState([]);
    const [exclusiveProducts, setExclusiveProducts] = useState([]);

    const [anchorEl, setAnchorEl] = useState(null);
    const [activePopover, setActivePopover] = useState(null);

    const [openProductPopup, setOpenProductPopup] = React.useState(false);
    const [popupProducts, setPopupProducts] = React.useState([]);
    const [productType, setProductType] = React.useState("");

    useEffect(() => {
        return subscribeSchemeFromDate(setFromDate);
    }, []);


    useEffect(() => {
        if (offerLevelDetails?.levelType?.id == 10) {
            setFormData(prev => ({
                ...prev,
                minValue: "",
                maxValue: "",
                discount: "",
                amount: "",
                fromDate: fromDate,
                toDate: "",
            }));
        }
        if (offerLevelDetails?.levelType?.id == 11) {
            setFormData(prev => ({
                ...prev,
                minQty: "",
                maxQty: "",
                discount: "",
                amount: "",
                fromDate: fromDate,
                toDate: "",
            }));
        }

        setInclusiveProducts([]);
        setExclusiveProducts([]);

    }, [offerLevelDetails?.levelType?.id, offerLevelDetails?.categories]);


    useEffect(() => {
        if (schemeConditonsValidations) {
            schemeConditonsValidations(() => validate);
        }

        if (schemeConditionsDetails) {
            schemeConditionsDetails({ formData, rows, inclusiveProducts });
        }
    }, [formData, rows, inclusiveProducts]);


    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
        setErrors(prev => ({ ...prev, [field]: "" }));
        setShake(prev => ({ ...prev, [field]: false }));
    };

    /* ---------- VALIDATION ---------- */
    const validate = () => {
        let valid = true;
        const newErrors = {};
        const newShake = {};

        const levelType = offerLevelDetails?.levelType?.id;

        const isQtyType =
            (levelType == 8 || levelType == 9 || levelType == 10);
        const isValueType = levelType == 11;

        const isDiscount = levelType == 10 || levelType == 11;

        const minQty = Number(formData.minQty);
        const maxQty = Number(formData.maxQty);
        const minValue = Number(formData.minValue);
        const maxValue = Number(formData.maxValue);

        // ---------- BASE REQUIRED VALIDATION ----------
        const rules = {
            discount: isDiscount && !formData.discount,

            amount: (offerLevelDetails?.levelType?.id == 8 ||
                offerLevelDetails?.levelType?.id == 9)
                && !formData.amount,

            toDate: !formData.toDate,

            minQty: isQtyType && !formData.minQty,
            maxQty: isQtyType && !formData.maxQty,

            minValue: isValueType && !formData.minValue,
            maxValue: isValueType && !formData.maxValue,

            inclusiveProduct:
                !Array.isArray(inclusiveProducts) ||
                inclusiveProducts.length === 0,
        };

        Object.entries(rules).forEach(([key, hasError]) => {
            if (hasError) {
                valid = false;
                newErrors[key] = `${key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase())} is required`;

                newShake[key] = true;
            }
        });

        // ---------- LOGICAL RANGE VALIDATION ----------
        if (isQtyType && minQty && maxQty && minQty >= maxQty) {
            valid = false;
            newErrors.minQty = "Minimum quantity must be less than maximum quantity";
            newErrors.maxQty = "Maximum quantity must be greater than minimum quantity";
        }

        if (isValueType && minValue && maxValue && minValue >= maxValue) {
            valid = false;
            newErrors.minValue = "Minimum value must be less than maximum value";
            newErrors.maxValue = "Maximum value must be greater than minimum value";
        }


        if (fromDate && formData.toDate) {

            if (fromDate > formData.toDate) {
                valid = false;

                newErrors.fromDate = dateValidationMsg;
                newErrors.toDate = toDateCannotBeLessThanFromDateMsg;
            }
        }


        /* Comment By Tejas (10-01-2026) to stop min/max cross row validation while adding */

        // const lastRow = rows?.length ? rows[rows.length - 1] : null;

        // ---------- CROSS ROW VALIDATION ----------
        // if (lastRow) {
        //     // 🔹 Quantity based comparison
        //     if (isQtyType && minQty) {
        //         const prevMaxQty = Number(lastRow.maxQty);

        //         if (!isNaN(prevMaxQty) && minQty <= prevMaxQty) {
        //             valid = false;
        //             newErrors.minQty =
        //                 "Minimum quantity must be greater than previous maximum quantity";
        //             newShake.minQty = true;
        //         }
        //     }

        //     // 🔹 Value based comparison
        //     if (isValueType && minValue) {
        //         const prevMaxValue = Number(lastRow.maxValue);

        //         if (!isNaN(prevMaxValue) && minValue <= prevMaxValue) {
        //             valid = false;
        //             newErrors.minValue =
        //                 "Minimum value must be greater than previous maximum value";
        //             newShake.minValue = true;
        //         }
        //     }
        // }

        // Trigger shake animation
        Object.keys(newErrors).forEach((key) => {
            setTimeout(() => {
                setShake((prev) => ({ ...prev, [key]: false }));
            }, 400);
        });

        setErrors(newErrors);
        setShake(newShake);

        return {
            isValid: valid,
            data: formData,
        };
    };

    const handleAdd = () => {
        const { isValid } = validate();
        if (!isValid) return;

        const objectToSave = {
            id: Date.now(),
            fromDate: fromDate || "",
            toDate: formData?.toDate || "",
            minQty: formData?.minQty || "",
            maxQty: formData?.maxQty || "-",
            minValue: formData?.minValue || "",
            maxValue: formData?.maxValue || "-",
            discount: formData?.discount || "-",
            amount: formData?.amount || "-",
            valueType: offerLevelDetails?.levelType?.id == 10 ? 0 : 1,
            inclusiveProductIds: inclusiveProducts,
            exclusiveProductIds: exclusiveProducts,
        };
        setRows((prev) => [...prev, objectToSave]);

        setFormData({
            ...formData,
            minQty: "",
            maxQty: "",
            minValue: "",
            maxValue: "",
            discount: "",
            amount: "",
            fromDate: fromDate,
            toDate: "",
        });
        setExclusiveProducts([]);
    };

    /*Comment By Tejas 12-01-2026 */
    // const handleInclusiveClick = (row) => {

    //     const inclusiveProductDetails =
    //         row.inclusiveProductIds.map((dataObj, i) => {
    //             return {
    //                 ...dataObj,
    //                 index: i + 1,
    //             }
    //         });

    //     setProductType(0)
    //     setPopupProducts(inclusiveProductDetails || []);
    //     setOpenProductPopup(true);
    // };


    const handleExclusiveClick = (row) => {

        const exclusiveProductIds =
            row.exclusiveProductIds.map((dataObj, i) => {
                return {
                    ...dataObj,
                    index: i + 1,
                }
            });

        setProductType(1)
        setPopupProducts(exclusiveProductIds || []);
        setOpenProductPopup(true);
    };


    const rowDelete = (rowData) => {
        swal({
            title: areYouSureMsg,
            text: deleteWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                const updatedRows = rows.filter(
                    (row) => row.id !== rowData.id
                );
                setRows(updatedRows);
            }
        });
    };


    return (

        <div className="card-scheme">
            <div className="card-title-scheme">📦 Offer Conditions</div>
            <div className="date-row">
                <div className={`date-field ${shake.fromDate ? "shake-error" : ""}`}>
                    <label className="required-label">From Date</label>
                    <input
                        className={`input-scheme ${errors.fromDate ? "error-input" : ""}`}
                        type="date"
                        value={fromDate}
                        onChange={(e) => handleChange("fromDate", e.target.value)}
                        disabled={true}
                    />
                    {errors.fromDate && <span className="error">{errors.fromDate}</span>}
                </div>

                <div className={`date-field ${shake.toDate ? "shake-error" : ""}`}>
                    <label className="required-label">To Date</label>
                    <input
                        className={`input-scheme ${errors.toDate ? "error-input" : ""}`}
                        type="date"
                        value={formData.toDate}
                        onChange={(e) => handleChange("toDate", e.target.value)}
                    />
                    {errors.toDate && <span className="error">{errors.toDate}</span>}
                </div>
            </div>

            <div style={{ display: "flex", gap: "20px" }}>
                {/* ================= INCLUSIVE PRODUCT ================= */}
                <div
                    ref={inclusiveAnchorRef}
                    className={shake.inclusiveProduct ? "shake-error" : ""}
                    style={{ width: "100%" }}
                >
                    <label className="required-label">Inclusive Product</label>

                    <AutocompleteCompo
                        multiple
                        options={productFromCatogoriesList}
                        value={inclusiveProducts}
                        onChange={(e, value) => {
                            setInclusiveProducts(value);

                            if (value.length === 0 && activePopover === "inclusive") {
                                setAnchorEl(null);
                                setActivePopover(null);
                            }
                        }}
                        getOptionLabel={(option) => option.name}
                        placeholder="Select Inclusive Product"
                        error={errors.inclusiveProduct}
                        helperText={errors.inclusiveProduct}
                        enableSelectActions
                        onSelectAll={() =>
                            setInclusiveProducts(productFromCatogoriesList)
                        }
                        onRemoveAll={() => {
                            setInclusiveProducts([]);
                            setAnchorEl(null);
                            setActivePopover(null);
                        }}
                        renderTags={(value, getTagProps) => {
                            const visible = value.slice(0, 2);
                            const hiddenCount = value.length - visible.length;

                            return (
                                <>
                                    {visible.map((option, index) => (
                                        <Chip
                                            {...getTagProps({ index })}
                                            key={option.id}
                                            label={option.name}
                                            size="small"
                                            sx={{
                                                maxWidth: "calc(100% - 8px)",
                                                "& .MuiChip-label": {
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }
                                            }}
                                        />
                                    ))}

                                    {hiddenCount > 0 && (
                                        <Chip
                                            label={`+${hiddenCount}`}
                                            size="small"
                                            onClick={() => {
                                                setAnchorEl(inclusiveAnchorRef.current);
                                                setActivePopover("inclusive");
                                            }}
                                            sx={{
                                                backgroundColor: lightWhiteFadeColor,
                                                color: blueFadeColor,
                                                cursor: "pointer",
                                                fontWeight: 600,
                                            }}
                                        />
                                    )}
                                </>
                            );
                        }}
                    />
                </div>

                {/* ================= EXCLUSIVE PRODUCT ================= */}
                <div
                    ref={exclusiveAnchorRef}
                    style={{ width: "100%" }}
                >
                    <label>Exclusive Product</label>

                    <AutocompleteCompo
                        multiple
                        options={productFromCatogoriesList}
                        value={exclusiveProducts}
                        onChange={(e, value) => {
                            setExclusiveProducts(value);

                            if (value.length === 0 && activePopover === "exclusive") {
                                setAnchorEl(null);
                                setActivePopover(null);
                            }
                        }}
                        getOptionLabel={(option) => option.name}
                        placeholder="Select Exclusive Product"
                        error={errors.exclusiveProduct}
                        helperText={errors.exclusiveProduct}
                        enableSelectActions
                        onSelectAll={() =>
                            setExclusiveProducts(productFromCatogoriesList)
                        }
                        onRemoveAll={() => {
                            setExclusiveProducts([]);
                            setAnchorEl(null);
                            setActivePopover(null);
                        }}
                        renderTags={(value, getTagProps) => {
                            const visible = value.slice(0, 2);
                            const hiddenCount = value.length - visible.length;

                            return (
                                <>
                                    {visible.map((option, index) => (
                                        <Chip
                                            {...getTagProps({ index })}
                                            key={option.id}
                                            label={option.name}
                                            size="small"
                                            sx={{
                                                maxWidth: "calc(100% - 8px)",
                                                "& .MuiChip-label": {
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }
                                            }}
                                        />
                                    ))}

                                    {hiddenCount > 0 && (
                                        <Chip
                                            label={`+${hiddenCount}`}
                                            size="small"
                                            onClick={() => {
                                                setAnchorEl(exclusiveAnchorRef.current);
                                                setActivePopover("exclusive");
                                            }}
                                            sx={{
                                                backgroundColor: lightWhiteFadeColor,
                                                color: blueFadeColor,
                                                cursor: "pointer",
                                                fontWeight: 600,
                                            }}
                                        />
                                    )}
                                </>
                            );
                        }}
                    />
                </div>
            </div >

            <MultiSelectPopover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                items={
                    activePopover === "inclusive"
                        ? inclusiveProducts
                        : exclusiveProducts
                }
                onClose={() => {
                    setAnchorEl(null);
                    setActivePopover(null);
                }}
                onRemove={(item) => {
                    const updater =
                        activePopover === "inclusive"
                            ? setInclusiveProducts
                            : setExclusiveProducts;

                    updater((prev) => {
                        const updated = prev.filter((p) => p.id !== item.id);

                        if (updated.length === 0) {
                            setAnchorEl(null);
                            setActivePopover(null);
                        }

                        return updated;
                    });
                }}
            />


            <div className="highlight-scheme mt-18">
                {(offerDetails?.offerType == 1 || offerDetails?.offerType == 0) && (
                    <>
                        {(offerLevelDetails?.levelType?.id == 8 ||
                            offerLevelDetails?.levelType?.id == 9 ||
                            (offerLevelDetails?.levelType?.id == 10)) && (
                                <>
                                    <div
                                        className={`${shake.minQty ? "shake-error" : ""} ${errors.minQty
                                            ? "input-error" : ""}`}

                                    >
                                        <label className="required-label">Min Quantity</label>
                                        <input
                                            className={"input-scheme"}
                                            type="number"
                                            min="1"
                                            step="1"
                                            value={formData.minQty}
                                            onKeyDown={(e) => {
                                                if (e.key === "-" || e.key === "e") {
                                                    e.preventDefault();
                                                }

                                                if (e.key === "0" && !formData.minQty) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onChange={(e) => handleChange("minQty", e.target.value)}
                                        />
                                        {errors.minQty && (
                                            <span className="error">{errors.minQty}</span>
                                        )}
                                    </div>

                                    <div
                                        className={`${shake.maxQty ? "shake-error" : ""} ${errors.maxQty
                                            ? "input-error" : ""}`}

                                    >
                                        <label className="required-label">Max Quantity</label>
                                        <input
                                            className={"input-scheme"}
                                            type="number"
                                            min="1"
                                            step="1"
                                            value={formData.maxQty}
                                            onKeyDown={(e) => {
                                                if (e.key === "-" || e.key === "e") {
                                                    e.preventDefault();
                                                }

                                                if (e.key === "0" && !formData.maxQty) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onChange={(e) => handleChange("maxQty", e.target.value)}
                                        />
                                        {errors.maxQty && (
                                            <span className="error">{errors.maxQty}</span>
                                        )}
                                    </div>
                                </>
                            )}

                        {offerLevelDetails?.levelType?.id == 11 && (
                            <>
                                <div
                                    className={`${shake.minValue ? "shake-error" : ""} ${errors.minValue
                                        ? "input-error" : ""}`}

                                >
                                    <label className="required-label">Min Value</label>
                                    <input
                                        className={"input-scheme"}
                                        type="number"
                                        min="1"
                                        step="1"
                                        value={formData.minValue}
                                        onKeyDown={(e) => {
                                            if (e.key === "-" || e.key === "e") {
                                                e.preventDefault();
                                            }

                                            if (e.key === "0" && !formData.minValue) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => handleChange("minValue", e.target.value)}
                                    />
                                    {errors.minValue && (
                                        <span className="error">{errors.minValue}</span>
                                    )}
                                </div>

                                <div
                                    className={`${shake.maxValue ? "shake-error" : ""} ${errors.maxValue
                                        ? "input-error" : ""}`}

                                >
                                    <label className="required-label">Max Value</label>
                                    <input
                                        className={"input-scheme"}
                                        type="number"
                                        min="1"
                                        step="1"
                                        value={formData.maxValue}
                                        onKeyDown={(e) => {
                                            if (e.key === "-" || e.key === "e") {
                                                e.preventDefault();
                                            }

                                            if (e.key === "0" && !formData.maxValue) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => handleChange("maxValue", e.target.value)}
                                    />
                                    {errors.maxValue && (
                                        <span className="error">{errors.maxValue}</span>
                                    )}
                                </div>
                            </>
                        )}


                        {(offerLevelDetails?.levelType?.id == 8 ||
                            offerLevelDetails?.levelType?.id == 9) ? (
                            <>
                                <div
                                    className={`${shake.amount ? "shake-error" : ""} ${errors.amount
                                        ? "input-error" : ""}`}

                                >
                                    {offerLevelDetails?.levelType?.id == 9 ?
                                        (<label className="required-label">Unit Value</label>) :
                                        (<label className="required-label">Flat Amount</label>)
                                    }
                                    <input
                                        className={"input-scheme"}
                                        type="number"
                                        value={formData.amount}
                                        onChange={(e) => handleChange("amount", e.target.value)}
                                    />
                                    {errors.amount && (
                                        <span className="error">{errors.amount}</span>
                                    )}
                                </div>
                            </>
                        ) : (offerLevelDetails?.levelType?.id == 10 ||
                            offerLevelDetails?.levelType?.id == 11) && (
                            <>
                                <div
                                    className={`${shake.discount ? "shake-error" : ""} ${errors.discount
                                        ? "input-error" : ""}`}

                                >
                                    <label className="required-label">Flat Discount (%)</label>
                                    <input
                                        className={"input-scheme"}
                                        type="number"
                                        min="0"
                                        step="0"
                                        value={formData.discount}
                                        onKeyDown={(e) => {
                                            if (
                                                e.key === "-" ||
                                                e.key === "e" ||
                                                e.key === "." && !formData.discount
                                            ) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => handleChange("discount", e.target.value)}
                                    />
                                    {errors.discount && (
                                        <span className="error">{errors.discount}</span>
                                    )}
                                </div>

                            </>
                        )}
                    </>
                )}
            </div>

            {
                (offerLevelDetails?.levelType?.id == 10
                    || offerLevelDetails?.levelType?.id == 11) && (
                    <div style={{
                        justifyContent: "flex-end",
                        display: "flex",
                        marginTop: "15px",
                        marginBottom: "15px"
                    }}>
                        <button className="sub-button" onClick={handleAdd}>
                            <AddIcon fontSize="small" /> Add
                        </button>
                    </div>
                )
            }

            {/* ---------- TABLE ---------- */}
            {
                rows.length > 0 && (
                    <div className="table-wrapper mt-18">
                        <table className="condition-table">
                            <thead>
                                <tr>
                                    <th>Sr.No</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Minimum</th>
                                    <th>maximum</th>
                                    <th>Discount (%)</th>
                                    {/* Commented By Tejas (12-01-2025) to hide inclusive product count 
                                 <th>Inclusive Product Count</th> */}
                                    <th>Exclusive Product Count</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={row.id}>
                                        <td>{index + 1}</td>
                                        <td>{getFormattedDateWithConvertingObj(row?.fromDate) || "-"}</td>
                                        <td>{getFormattedDateWithConvertingObj(row?.toDate) || "-"}</td>
                                        <td>{row?.valueType == 0 ? row?.minQty : row?.minValue}</td>
                                        <td>{row?.valueType == 0 ? row?.maxQty : row?.maxValue}</td>
                                        <td>{row?.discount}</td>
                                        {/* Commented By Tejas (12-01-2025) to hide inclusive product count 
                                     <td
                                        onClick={() => handleInclusiveClick(row)}
                                        style={{
                                            cursor: "pointer",
                                            color: "#1c83ff",
                                            fontWeight: 600,
                                        }}
                                        title="View Inclusive Products"
                                    >
                                        {row?.inclusiveProductIds?.length || 0}
                                    </td> */}
                                        <td
                                            onClick={() => handleExclusiveClick(row)}
                                            style={{
                                                cursor: "pointer",
                                                color: redColor,
                                                fontWeight: 600,
                                            }}
                                            title="View Exclusive Products"
                                        >
                                            {row?.exclusiveProductIds?.length || 0}
                                        </td>                                    <td>
                                            <IconButton onClick={() => rowDelete(row)}>
                                                <DeleteOutlineIcon color="error" />
                                            </IconButton>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )
            }

            {
                openProductPopup && (
                    <ProductDetailsPopup
                        open={openProductPopup}
                        onClose={() => setOpenProductPopup(false)}
                        products={popupProducts}
                        title={
                            productType !== "" ?
                                (productType == 0 ? "Inclusive Product Details" : "Exclusive Product Details")
                                : "Product Details"
                        }
                    />
                )
            }
        </div >
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(SchemeConditions);